export { default } from "@casino/external/icons/GenericDislike";
